import { createAction } from '@reduxjs/toolkit';

// Fix param types

export const manageDashboards = createAction<any>(
  'MANAGE_INTEGRATION_SETTINGS'
);

export const manageWidgets = createAction<any>('MANAGE_INTEGRATION_LINKING');
